export const COMEGO_ICON_MAP = {
  work: 'work_history',
  pause: 'pause',
  absence: 'beach_access',
  not_worked: 'home_filled',
};

export const COMEGO_MAX_DESCRIPTION = 250;
